module.exports = __webpack_public_path__ + "img/sideBlue.565b988b.png";